// Demo mode configuration. Everything in src/mocks/ is dynamically imported
// behind `process.env.REACT_APP_DEMO_MODE === 'true'`, so this file (and its
// transitive dependencies) is dropped from production bundles.

export const DEMO_ADVERTISER_ID = 1000003;

export const DEMO_ADVERTISER = {
  id: DEMO_ADVERTISER_ID,
  uuid: "00000000-0000-0000-0000-000000001003",
  name: "Apple",
  website: "https://www.apple.com",
  billing_type: "2",
  category: "Consumer Electronics",
  enabled_geo_types: ["state", "dma"],
  // Billing tab (DEV-1960) — pre-filled so the demo shows a working Billing
  // Method (read-only, since DEMO_USER isn't @audiohook.com) and an editable
  // Billing Details form out of the box.
  billing_method: "affiliate_platform",
  affiliate_platform: "Rakuten",
  affiliate_platform_custom_name: null,
  billing_company_name: "Apple Inc.",
  billing_address: "One Apple Park Way, Cupertino, CA 95014",
  accounting_email: "ap@apple.com",
  // Affiliate Platform Reporting integration (Integrations panel) — a
  // distinct field from billing_method's affiliate_platform above.
  affiliate_reporting_platform: "Impact",
};

// Stable demo identity. Email is intentionally NOT @audiohook.com so AuthGate
// routes to the regular MainLayout (not the support flow).
export const DEMO_USER = {
  id: "11111111-1111-1111-1111-111111111111",
  email: "alex.chen@apple.com",
  first_name: "Alex",
  last_name: "Chen",
  created_at: "2025-01-15T10:00:00.000Z",
};

// Synthetic Supabase session shape (only fields the app reads).
export const DEMO_SESSION = {
  access_token: "demo-access-token",
  refresh_token: "demo-refresh-token",
  expires_in: 3600,
  expires_at: Math.floor(Date.now() / 1000) + 3600,
  token_type: "bearer",
  user: {
    id: DEMO_USER.id,
    email: DEMO_USER.email,
    user_metadata: { full_name: `${DEMO_USER.first_name} ${DEMO_USER.last_name}` },
    app_metadata: { provider: "demo" },
  },
};
